import React from 'react';

const Input = ({ name, type, label, value, onChange, isRequired = false }) => {
  return (
    <div className="flex flex-col py-2">
      <label>
        {label}
        {isRequired && <span className="text-red-500 ml-1">*</span>}
      </label>
      <input
        className="border p-2"
        type={type}
        value={value}
        onChange={onChange}
        id={name}
        name={name}
        required={isRequired}
      />
    </div>
  );
};

export { Input };
